// @flow
import { ErrorPage, Footer } from "@nested/brand";
import { useSelector } from "react-redux";
import { gql, useQuery } from "@apollo/client";
import { useParams } from "react-router-dom";
import { NotFound } from "@nested/brand/src/pages/NotFound";
import { Loading } from "@nested/onboarding-form/src/OnboardingForm";
import { Node, GraphWrapper, BASE_DELAY } from "./AnimatedComponents";
import { CheckYourInbox } from "./CheckYourInbox";

const PERSONALISED_AVM_RESULT_QUERY = gql`
  query PersonalisedAVMResult($id: ID!) {
    avmValuationResult(id: $id) {
      id
      property {
        id
        outcode
        relationshipManager {
          id
          firstName
          email
        }
      }
    }
  }
`;

export const PersonalisedAVMValuationResult = () => {
  const { id } = useParams();
  const { data, loading, error } = useQuery(PERSONALISED_AVM_RESULT_QUERY, {
    variables: { id },
    skip: !id,
  });

  const formState = useSelector((state) => state);
  const customerEmail = formState.onboardingForm?.contactDetails?.email;
  const bedroomCount = formState.onboardingForm?.propertyDetails?.bedrooms;

  if (!id) {
    return (
      <>
        <NotFound />
        <Footer />
      </>
    );
  }

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <ErrorPage />;
  }

  if (!data?.avmValuationResult) {
    return (
      <>
        <NotFound />
        <Footer />
      </>
    );
  }

  const {
    property: { outcode },
    property: {
      relationshipManager: { firstName: rmFirstName, email: rmEmail },
    },
  } = data.avmValuationResult;

  return (
    <>
      <GraphWrapper>
        <Node
          hasEdge
          message={`Searching for ${bedroomCount} bed properties in ${outcode}`}
        />
        <Node
          hasEdge
          message="Expanding search area"
          subMessage="Looking for more accurate data"
          position={1}
        />
        <Node
          hasEdge
          message="Searching for your local agent"
          subMessage={"Found"}
          position={2}
        />
        <Node
          message={`Contacting ${rmFirstName} for a local expert valuation`}
          position={3}
        />
      </GraphWrapper>
      <CheckYourInbox
        outcode={outcode}
        rmEmail={rmEmail}
        rmFirstName={rmFirstName}
        customerEmail={customerEmail}
        delay={4 * BASE_DELAY + 300}
      />
      <Footer />
    </>
  );
};
